import React from 'react';
import { connect } from 'react-redux';
import { PapiUser, PapiGallection } from '@wix/da-types-papi';
import EditConfigButton from '../../../UserWidgets/_partials/WidgetEditControls/EditConfigButton';
import MediaManager from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { GallectionType } from '../../../../../types/gallection';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';
import Modal from 'react-modal';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';

import s from './EditGallectionButton.scss';

export interface Props {
  gallection?: PapiGallection;
  className?: string;
}

export interface State {
  showMediaManager: boolean;
  isReloading: boolean;
}

const defaultState = {
  showMediaManager: false,
  isReloading: false,
};

const enhance = connect(state => ({
  gallectionType: getGallectionSectionType(state),
  profileOwnerUser: getProfileOwnerUser(state),
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
}));
class EditGallectionButton extends React.Component<
  Props & {
    gallectionType: GallectionType;
    profileOwnerUser: PapiUser;
    isCurrentUserProfileOwner: boolean;
  },
  State
> {
  state: State = defaultState;
  render() {
    if (!this.props.isCurrentUserProfileOwner) {
      return null;
    }
    return (
      <>
        <EditConfigButton
          className={this.props.className}
          onClick={() => this.setState({ showMediaManager: true })}
        />
        {this.state.showMediaManager && (
          <MediaManager
            initialMediaSource={
              this.props.gallectionType === 'gallery'
                ? MediaSourceType.GALLERY
                : MediaSourceType.COLLECTION
            }
            gallectionFolder={this.props.gallection}
            onClose={this.closeAndReload}
            onDone={this.closeAndReload}
          />
        )}
        {this.state.isReloading && (
          <Modal
            isOpen
            className="override"
            overlayClassName={s['reload-overlay']}
          >
            <LoadingIndicator coverMode withOverlay={true} view="daSymbol" />
          </Modal>
        )}
      </>
    );
  }
  closeAndReload = event => {
    this.setState({
      showMediaManager: false,
      isReloading: true,
    });
    event && event.preventDefault();
    window.location.reload();
  };
}

export default enhance(EditGallectionButton) as React.ComponentType<Props>;
